<template>
  <Block type="accountSetting" id="accountUpgrade">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.upgrade"
    ></common-header>
    <form id="changePasswordForm">
      <Editor
        v-model="accountName"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :placeholder="accountLanguages.accountName"
      ></Editor>
      <Editor
        v-model="password"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        editorType="password"
        :placeholder="accountLanguages.password"
      ></Editor>
      <Editor
        v-model="repassword"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        editorType="password"
        :placeholder="accountLanguages.repeatPassword"
      ></Editor>
      <!-- <Agreements v-on:changeAgreeTerms="selectTerm"></Agreements> -->
      <label class="agree-wrapper">
        <Button
          type="fillLight"
          class="btn account-setting-submit"
          data-asyncbtn
          @click="upgrade"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ accountLanguages.submit }}
        </Button>
      </label>
    </form>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="accountLanguages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>
<script>
import { UPGRADE } from '../../store/passport/accountSetting';
import AccountSettingMixins from '../../mixins/AccountSetting';
// import Agreements from "../../components/passport/Agreements";
import commonHeader from '@/resource/components/support/header';
import globalConfig from '../../utiles/globalConfig';
import bridge from '../../utiles/bridge';
export default {
  data() {
    return {
      accountName: '',
      password: '',
      repassword: '',
      terms: true,
      isSDK: false
    };
  },
  mixins: [AccountSettingMixins],
  methods: {
    upgrade() {
      this.$store
        .dispatch(UPGRADE, {
          accountName: this.accountName,
          password: this.password,
          repassword: this.repassword,
          terms: this.terms,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true
        })
        .then(success => {
          if (success) {
            // dana渠道处理：账号升级成功，并且带有toAccountUpgrade参数，则在账号升级成功后，自动关闭用户中心并且，调起dana储值
            if (
              globalConfig.isDanaMiniProgram() &&
              globalConfig.getHrefParam('toAccountUpgrade') === '1'
            ) {
              bridge.callSdkMethod('danaAccountUpgradeSuccess', {}, _res => {});
            }
            setTimeout(() => {
              this.$router.back(-1);
            }, 500);
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    }
  },
  components: {
    // Agreements
    commonHeader
  },
  mounted() {
    this.selectTerm(true);
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
  }
};
</script>
